import { useTranslations } from '@aikoa/i18n/react'
import { useMutation } from '@tanstack/react-query'
import { View } from 'react-native'
import { Text } from '~/components/ui/text'
import { ToggleButton } from '~/components/ui/toggle-button'
import { useUserId } from '~/components/user/SessionProvider'
import { queryClient, trpc } from '~/lib/trpc'

export function SelectRole() {
  const userId = useUserId()
  const { t } = useTranslations('user')

  const setAuthRoleMutation = useMutation(
    trpc.users.setExclusiveRole.mutationOptions({
      onSuccess: () =>
        queryClient.invalidateQueries({
          queryKey: ['userProfile', 'current'],
        }),
    })
  )

  return (
    <View>
      <Text>{t(($) => $.selectRole.title)}</Text>
      <Text>{t(($) => $.selectRole.workInProgress)}</Text>
      <View className="w-full flex-1 flex-row gap-4">
        <ToggleButton
          className="flex-1 border-primary/50 bg-transparent aria-selected:border-accent-foreground/30 aria-selected:bg-primary"
          textClassName="text-primary/90 group-aria-selected/button:text-accent-foreground"
          value={false}
          onValueChange={() => setAuthRoleMutation.mutate({ userId, role: 'realtor' })}>
          {t(($) => $.selectRole.realtor)}
        </ToggleButton>
        <ToggleButton
          className="flex-1 border-primary/50 bg-transparent aria-selected:border-accent-foreground/30 aria-selected:bg-primary"
          textClassName="text-primary/90 group-aria-selected/button:text-accent-foreground"
          value={false}
          onValueChange={() => setAuthRoleMutation.mutate({ userId, role: 'buyer' })}>
          {t(($) => $.selectRole.buyer)}
        </ToggleButton>
      </View>
    </View>
  )
}
